import React from 'react';
import { a } from 'react-router-dom';


const Footer = () => {
    return (
        <>

            <div className="bg-light text-center text-white">
                <div className="container-fluid p-0" style={{ backgroundColor: " #F2F3F4", color: "white" }}>

                    <div className="py-3  text-center ">
                        <a className="btn btn-primary btn-floating m-1" style={{ backgroundColor: " #55acee" }}
                            href="https://twitter.com/home?lang=en"
                        ><i className="fab fa-twitter"></i></a>

                        <a className="btn btn-primary btn-floating m-1" style={{ backgroundColor: "#0082ca" }}
                            href="https://www.linkedin.com/in/sumit-singh-8a61011b6/"
                        ><i
                            className="fab fa-linkedin-in"></i></a>
                        <a className="btn btn-primary btn-floating m-1" style={{ backgroundColor: "#333333;" }}
                            href="https://github.com/sumit1843007"
                        ><i className="fab fa-github"></i></a>
                    </div>

                    <div className="text-black py-2 text-center menu-btn" style={{ backgroundColor: " rgba(0, 0, 0, 0.2)", color: "white" }} >
                        © Copyright: sumit1843007
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;
